import UnderExternalAdministration from './UnderExternalAdministration.router';

export default UnderExternalAdministration;

export { default as underExternalAdministrationRoutes } from './routes';
